import { Redirect } from 'react-router-dom';

const TestPreferenceRedirect = () => <Redirect to="/tests/preferences-personnalites" />;

export default TestPreferenceRedirect;
